import { baseURL } from "@/services/api";

export const PrivacyPolicy = () => {
  return (
    <div className="flex flex-1 flex-grow ml-[10px] flex-wrap">
      <div>By signing up you agree to our &nbsp;</div>
      <a
        href={`${baseURL}templates/termsandconditions.html`}
        target="_blank"
        className="italic underline"
      >
        <div className="underline italic">Terms and conditions</div>
      </a>
      <div>&nbsp;and&nbsp;</div>
      <a
        href={`${baseURL}templates/privacypolicy.html`}
        target="_blank"
        className="italic underline"
      >
        <div className="underline italic">Privacy Policy</div>
      </a>
    </div>
  );
};
